// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"6d649ea0","377":"9146a53b","453":"e3dac489","578":"e4b6a17f","861":"e5fd3662","977":"b7398998"}[chunkId] + ".chunk.js";
};